import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState } from "react";
import axios from "axios";
import "./vendor.css";
import { useNavigate } from "react-router-dom";

function Createvendor() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([
    "raw_material",
    "packaging",
    "service",
    "others",
  ]);

  const [newCategory, setNewCategory] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    email: "",
    phone: "",
    address: "",
    category: "",
    productsOrServices: "",
    gst: "",
    acc: "",
    ifsc: "",
    pan: "",
    hsn: "",
  });

  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (
      ["name", "contactPerson", "address", "productsOrServices"].includes(name)
    ) {
      updatedValue = capitalizeWords(value);
    }

    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${INVENTORY_API_BASE_URL}/create-vendor`,
        formData
      );
      alert("Vendor created successfully!");
      setFormData({
        name: "",
        contactPerson: "",
        email: "",
        phone: "",
        address: "",
        category: "",
        productsOrServices: "",
        gst: "",
        acc: "",
        ifsc: "",
        pan: "",
        hsn: "",
      });
      navigate("/Vendorlist");
    } catch (error) {
      console.error("Error creating vendor:", error);
      alert("Failed to create vendor.");
    }
  };

  return (
    <form className="createvendor-container" onSubmit={handleSubmit}>
      <h3 style={{ textAlign: "center" }}>Create Vendor</h3>

      <div>
        <label>Vendor Name:</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Contact Person:</label>
        <input
          type="text"
          name="contactPerson"
          value={formData.contactPerson}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Phone:</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Address:</label>
        <textarea
          name="address"
          rows="3"
          value={formData.address}
          onChange={handleChange}
          required
        ></textarea>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <label style={{ minWidth: "120px" }}>Vendor Category:</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
          style={{ flex: "1" }}
        >
          <option value="">Select Category</option>
          {categories.map((cat, index) => (
            <option key={index} value={cat}>
              {cat.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Add New Category"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          style={{ flex: "1" }}
        />
        <button
          type="button"
          onClick={() => {
            const trimmed = newCategory
              .trim()
              .toLowerCase()
              .replace(/\s+/g, "_");
            if (trimmed && !categories.includes(trimmed)) {
              setCategories([...categories, trimmed]);
              setNewCategory("");
            }
          }}
        >
          Add
        </button>
      </div>

      <div>
        <label>Products or Services:</label>
        <textarea
          name="productsOrServices"
          rows="3"
          value={formData.productsOrServices}
          onChange={handleChange}
          required
        ></textarea>
      </div>

      <div>
        <label>Gst Number:</label>
        <input
          type="text"
          name="gst"
          value={formData.gst}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Pan Card Number:</label>
        <input
          type="text"
          name="pan"
          value={formData.pan}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>HSN Number:</label>
        <input
          type="text"
          name="hsn"
          value={formData.hsn}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Bank Account Number:</label>
        <input
          type="text"
          name="acc"
          value={formData.acc}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>IFSC Code:</label>
        <input
          type="text"
          name="ifsc"
          value={formData.ifsc}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button type="submit">Submit</button>
      </div>
    </form>
  );
}

export default Createvendor;
